import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
export default {
	name: 'backorderList',
	components: {
		Paginate,
		DatePicker,
		VueElementLoading
	},
	data: function() {
		return {
			currentPage: 0,
			totalRows: 0,
			currentPage2: 0,
			showDetailModal: false,
			currentBODetailID: '',
			resultCount: 0,
			resultCountStn: 0,
			RTOaction: '',
			warehouseid: 0,
			listBackorderData: [],
			listSTNOrderData: [],
			boDetailData: [],
			pageno: 0,
			pagecount: 0,
			pagenostn: 0,
			pagecountstn: 0,
			useremail: '',
			awbno: '',
			orderid: '',
			useremail: '',
			listingtypeflag: 'BO',
			pageLoaded: false,
			detailLength: 0,
			addmodalShow: false,
			modalshow: false,
			isCancel: false,
			modifiedDate: '',
			isLoading: false,
			isLoader: false,
			canceltype: false,
			STNcreated: false,
			modifiedby: '',
			isdata: true,
			STNdetailLength: [],
			STNDetailData: [],
			BOmodalHeading: '',
			listClientData: [],
			listClientData: [],
			listWarehouseData: [],
			client: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			ClientErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
		}
	},
	created: function() {},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail.email;
		this.pageno = 0;
		this.pagenostn = 0;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		//this.getBackOrderList();
		// this.getClientList();
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				// this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}


		//this.getStnOrderList();
	},
	methods: {
		closeaddmodalShow() {
			this.addmodalShow = false;
			this.showDetailModal = false;
		},
		addmodal() {
			this.addmodalShow = true
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	this.clientid = this.client;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.clientid) {
		// 		// this.getMerchantList();
		// 		if (this.warehouseid) {
		// 			// this.getStnOrderList();
		// 			// this.getBackOrderList();
		// 		} else {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getStnOrderList();
		// 			// this.getBackOrderList();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },


		getBackOrderList() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.pageCount = 0;
				return false;
			}
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.pageCount = 0;

				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.resultCount = 0;
			var listtype = 'BO'
			this.isLoading = true
			this.input = ({
				offset: this.pageno,
				limit: 10,
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				awbno: this.awbno,
				orderid: this.orderid,
				listingtype: listtype,
				clientid: localStorage.getItem("selectedClient"),
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBackOrderlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false
					this.listBackorderData = result.data.data
					this.totalRows = result.data.count
					this.resultCount = result.data.count
					if (this.totalRows < 10) {
						this.pagecount = 1
					} else {
						this.pagecount = Math.ceil(this.totalRows / 10)
					}
				}, error => {
					console.error(error)
				})
		},


		getStnOrderList() {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.resultCountStn = 0;
			var listtype = 'STN'
			this.input = ({
				offset: this.pagenostn,
				limit: 10,
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				awbno: this.awbno,
				orderid: this.orderid,
				listingtype: listtype,
				clientid: localStorage.getItem("selectedClient"),
			})
			this.isLoading = true
			if (localStorage.getItem("selectedClient") != '') {
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getBackOrderlist',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listSTNOrderData = result.data.data
						this.totalRows = result.data.count
						this.resultCountStn = result.data.count
						if (this.totalRows < 10) {
							this.pagecountstn = 1
						} else {
							this.pagecountstn = Math.ceil(this.totalRows / 10)
						}
						this.isLoading = false
					}, error => {
						console.error(error)
					})
			} else {
				this.ClientErr = this.$t('common.clientError');
			}
		},
		getOrderTypeListSearch() {
			this.pageno = 0;
			this.pagenostn = 0;
			if (this.listingtypeflag == 'BO') {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.resultCountStn = 0;
				var listtype = 'BO'
				this.input = ({
					offset: this.pagenostn,
					limit: 10,
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					awbno: this.awbno,
					orderid: this.orderid,
					listingtype: listtype,
					clientid: localStorage.getItem("selectedClient"),
				})
			} else {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.resultCountStn = 0;
				var listtype = 'STN'
				this.input = ({
					offset: this.pagenostn,
					limit: 10,
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					awbno: this.awbno,
					orderid: this.orderid,
					listingtype: listtype,
					clientid:localStorage.getItem("selectedClient"),
				})
			}
			if (localStorage.getItem("selectedClient") != '') {
				this.isLoading = true
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getBackOrderlist',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						// chhecking  the tab which is open and settinf the response
						if (this.listingtypeflag == 'BO') {
							this.listBackorderData = result.data.data
							this.totalRows = result.data.count
							this.resultCount = result.data.count
							if (this.totalRows < 10) {
								this.pagecount = 1
							} else {
								this.pagecount = Math.ceil(this.totalRows / 10)
							}
						} // End Iff
						else {
							this.listSTNOrderData = result.data.data
							this.totalRows = result.data.count
							this.resultCountStn = result.data.count
							if (this.totalRows < 10) {
								this.pagecountstn = 1
							} else {
								this.pagecountstn = Math.ceil(this.totalRows / 10)
							}
						} // END Else
						this.isLoading = false
					}, error => {
						console.error(error)
					})
			} else {
				this.ClientErr = this.$t('common.clientError');
			}
		},
		//to reset search form
		resetSearchForm() {
			this.orderid = '';
			this.isCancel = '';
			this.client = "";
			this.warehouse = "";
			this.totalRows = 0;
			this.listBackorderData = [];
			this.listSTNOrderData = [];
			if (this.listingtypeflag == 'BO') {
				// this.getBackOrderList();
			} else {
				this.getStnOrderList();
			}
		},
		//to get pagination for back Order
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * 10
			this.getBackOrderList()
		},
		//to get pagination for stn Order
		getPaginationDataStn(currentPage2) {
			this.pagenostn = (currentPage2 - 1) * 10
			this.getStnOrderList()
		},
		// this function is called when a tab is changed , so that the list gets refreshed
		setOrderType(ordertype) {
			this.listingtypeflag = ordertype;
			if (ordertype == 'BO') {
				if (this.pageLoaded == true) {
					this.pageno = 0;
					this.getBackOrderList();
				}
			} else {
				this.pageLoaded = true;
				this.pagenostn = 0;
				this.getStnOrderList();
			}
		},
		showDetail(dataid, iscancelled, modifieddate, modifyby, canceltype, typ, isstncreated, clientid) {
			this.isCancel = iscancelled;
			this.canceltype = canceltype;
			this.modifiedby = modifyby;
			this.currentBODetailID = dataid;
			this.modifiedDate = modifieddate;
			this.showDetailModal = true;
			this.STNcreated = isstncreated;
			this.client = clientid
			if (typ == 'BO') {
				this.BOmodalHeading = "Back Order Details";
			} else {
				this.BOmodalHeading = "STN Details";
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoader = true;
			this.isdata = false;
			this.input = ({
				orderid: dataid,
				listingtype: typ,
				clientid: clientid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBackOrderDetail',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoader = false;
					this.isdata = true;
					this.boDetailData = result.data.data
					this.detailLength = result.data.data.length
				}, error => {
					console.error(error)
				})
		},
		//update Order status
		cancelOrder(currentBODetailID, clientid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				poid: currentBODetailID,
				modifyby: this.useremail,
				clientid: clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateBackOrder',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success("Backorder updated")
						this.isCancel = false;
						this.addmodalShow = false;
						this.showDetailModal = false;
						this.resetSearchForm();
						this.getBackOrderList();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		routeLinkModalFalse() {
			this.showDetailModal = false
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/reports/backorderlist/backorderlist.component.js